document.addEventListener('DOMContentLoaded', () => {
  const toggles = document.querySelectorAll('.footer-menu__toggle');

  toggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const item = toggle.closest('.footer-menu__item');
      const submenu = item ? item.querySelector('.footer-menu__sublist') : null;

      if (!item || !submenu) return;

      const isOpen = toggle.getAttribute('aria-expanded') === 'true';

      toggle.setAttribute('aria-expanded', String(!isOpen));
      item.classList.toggle('is-open', !isOpen);
      submenu.hidden = isOpen;
    });
  });




});

